import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from '@heroicons/react/24/solid';
import Seo from '../components/Seo';
import HeroSection from '../components/HeroSection';
import ApproachSection from '../components/ApproachSection';
import BehandlungenSection from '../components/BehandlungenSection';
import BenefitsSection from '../components/BenefitsSection';
import BeforeAfterGallery from '../components/BeforeAfterGallery';
import SocialProofSection from '../components/SocialProofSection';
import ExperienceSection from '../components/ExperienceSection';
import TeamSection from '../components/TeamSection';
import CtaSection from '../components/CtaSection';
import { useLanguage } from '../contexts/LanguageContext';
import { localizedPath } from '../seo/routes';

// Notfall-Teaser: stärkster interner Linkgeber (Startseite) → Notfall-Hub (Plan §7.6).
// Defensiv geguarded — fehlt emergency.homeTeaser, wird die Sektion nicht gerendert.
const EmergencyTeaserSection: React.FC = () => {
  const { translations, language } = useLanguage();
  const teaser = translations.emergency?.homeTeaser;
  if (!teaser?.title) return null;

  return (
    <section className="py-16 md:py-20 bg-navy">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto rounded-2xl border-l-4 border-coral bg-white/5 p-8 md:p-12 text-center md:text-left">
          <div className="flex flex-col md:flex-row md:items-center gap-8">
            <div className="flex-grow">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">{teaser.title}</h2>
              <p className="text-white/80 text-lg leading-relaxed">{teaser.body}</p>
            </div>
            <div className="flex flex-col gap-4 flex-shrink-0 items-center md:items-end">
              <a
                href="tel:+34603319648"
                className="inline-flex items-center justify-center gap-2 bg-coral text-white px-8 py-4 rounded-xl font-bold shadow-lg hover:bg-coral-dark transition-colors"
              >
                <PhoneIcon className="w-5 h-5" />
                603 31 96 48
              </a>
              {teaser.linkText && (
                <Link
                  to={localizedPath('emergency', language)}
                  className="text-mint font-semibold hover:text-white transition-colors underline"
                >
                  {teaser.linkText}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const HomePage: React.FC = () => {
  return (
    <main className="pt-20 lg:pt-32">
      <Seo pageKey="home" />
      <HeroSection />
      <ApproachSection />
      <BehandlungenSection />
      <BenefitsSection />
      <EmergencyTeaserSection />
      <BeforeAfterGallery />
      <SocialProofSection />
      <TeamSection />
      <ExperienceSection />
      <CtaSection />
    </main>
  );
};

export default HomePage; 